export const TreatArches = {
  BOTH: 'BOTH',
  LOWER_ONLY: 'LOWER_ONLY',
  UPPER_ONLY: 'UPPER_ONLY',
}

export type TreatArches = (typeof TreatArches)[keyof typeof TreatArches]
